import React, { FC, useRef } from "react";
import type { PlatformCardsProps } from "@/types";
import { ContentManager } from "../content-manager";
import { Image } from "../image";
import { useInView } from "@/hooks/reveal-in-view";

export const PlatformCards: FC<PlatformCardsProps> = ({ cards }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="platformCards">
      <div className="platformCards--inner">
        <div className="wrapper wrapper_lg">
          <div className="platformCards--content">
            <div className="platformCards--cards" ref={ref}>
              {cards.map((card, index) => {
                return (
                  <div
                    key={index}
                    className="platformCards--card"
                    style={{
                      transform: isInView
                        ? "none"
                        : `translateY(${20 * (index + 1)}px)`,
                      opacity: isInView ? 1 : 0,
                      transition:
                        "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                    }}
                  >
                    <div
                      className="platformCards--card-text"
                      onMouseEnter={(event) => {
                        const target = event.currentTarget as HTMLElement;
                        target.classList.add("hover-animation-bounce");
                      }}
                      onAnimationEnd={(event) => {
                        const target = event.target as HTMLElement;
                        target.classList.remove("hover-animation-bounce");
                      }}
                    >
                      {card.title && (
                        <ContentManager
                          content={card.title}
                          className="platformCards--card-title"
                        />
                      )}
                      {card.description && (
                        <ContentManager
                          content={card.description}
                          className="platformCards--card-description"
                        />
                      )}
                    </div>
                    <div className="platformCards--card-image-wrapper">
                      {card.image?.file?.url && (
                        <Image
                          className="platformCards--card-image"
                          src={card.image as any}
                          alt={card.image.title}
                        />
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
